/* eslint-disable no-undef */
import previewStore from "@/stores/previewStore";
const minSpeed = 0.5;
const maxSpeed = 4.0;
import ConfigStore from "@/stores/mixedConfig";
const MaterialType = {
    VIDEO: 1,
    AUDIO: 2,
    IMAGE: 3,
};
import QuickCutStore from "@/stores/quickCutStore";
import QuickStore from "@/stores/quickCutStore";
import {toJS} from "mobx";
import previewConfing from "@/stores/quickCutPreview";
import {batch_download} from "@/services/createSpace/material";

function generateCombinations(
    arr,
    combinationLength,
    usedElements,
    uniqueElements = false,
) {
    const results = [];

    function backtrack(start, currentCombination) {
        // 如果当前组合的长度等于指定长度，则调用验证函数
        if (currentCombination.length === combinationLength) {
            if (!uniqueElements || isUnique(currentCombination, usedElements)) {
                results.push([...currentCombination]);
                if (uniqueElements) {
                    currentCombination.forEach((item) => usedElements.add(item.id));
                }
            }
            return;
        }

        // 遍历数组并递归生成组合
        for (let i = start; i < arr.length; i++) {
            currentCombination.push(arr[i]);
            backtrack(i + 1, currentCombination);
            currentCombination.pop(); // 回溯
        }
    }

    backtrack(0, []);
    return results;
}

const isUnique = (comb, usedElements) => {
    const result = comb.every((item) => !usedElements.has(item.id));
    return result;
};

// 这里验证组合
const isValid = (comb, captionDurations, speed = "origin") => {
    const segsDuration = getMaterialsDuration(comb) / 1000;
    for (const capDuration of captionDurations) {
        if (speed === "follow_audio") {
            const speedFactor = Number(segsDuration) / Number(capDuration);
            if (speedFactor >= minSpeed && speedFactor <= maxSpeed) {
                // 这里是判断变速是否满足条件
                return true;
            }
        } else {
            if (segsDuration >= capDuration) {
                return true;
            }
        }
    }
    return false;
};

// 预估台词时长
const estimateDuration = (lines, wordsPerTime = 1 / 3, isSSML = false, isEn = false) => {
    if (lines.length === 0) {
        return 0;
    }
    if (isSSML) {
        const duration = lines.reduce(
            (acc, cur) => acc + estimateSSMLDuration(cur, wordsPerTime, isEn),
            0,
        );
        return duration + wordsPerTime * lines.length;
    }
    const combinedText = lines.join(",");
    const totalCharacters = combinedText.length;
    return totalCharacters * wordsPerTime;
};

function estimateSSMLDuration(ssml, wordsPerTime = 1 / 3, isEn = false) {
    // 匹配所有 <break> 标签并提取时间
    const breakRegex = /<break time=['"](.+?)['"]\/>/g;
    let breakMatch;
    let totalBreakTime = 0;

    // 遍历 <break> 标签并累加休止时间
    while ((breakMatch = breakRegex.exec(ssml)) !== null) {
        const breakTimeStr = breakMatch[1];
        // 将时间字符串转为数字
        const breakTime = parseFloat(breakTimeStr);
        totalBreakTime += breakTime;
    }

    // 去除所有 <break> 和其他标签，计算纯文本字数
    const textOnly = ssml.replace(/<[^>]+>/g, "");
    let textLength = textOnly.length;
    // 英文文本，按音节计算长度
    if (isEn) {
        textLength = countSyllables(textOnly)
    }

    // 按每3个字1秒计算文本时长
    const textDuration = textLength * wordsPerTime;

    // 总时长
    const totalDuration = textDuration + totalBreakTime;

    return Number(totalDuration.toFixed(2)); // 返回秒数，保留两位小数
}


const getMaterialsDuration = (materials) => {
    return materials.reduce((acc, cur) => acc + cur.duration, 0);
};
// 英文文本音节计数
function countSyllables(text) {
    // 将文本转换为小写，并去掉非字母字符
    text = text.toLowerCase().replace(/[^a-z\s]/g, "");

    // 按空格分割单词
    const words = text.split(/\s+/);

    // 定义元音集合
    const vowels = "aeiouy";

    // 音节计数
    let totalSyllables = 0;

    words.forEach(word => {
        let syllables = 0;
        let prevCharWasVowel = false;

        // 遍历每个字母
        for (let i = 0; i < word.length; i++) {
            const char = word[i];
            const isVowel = vowels.includes(char);

            // 如果当前是元音，且前一个字符不是元音，则计为一个音节
            if (isVowel && !prevCharWasVowel) {
                syllables++;
            }
            prevCharWasVowel = isVowel;

            // 特殊规则：单词结尾的静音 "e"
            if (i === word.length - 1 && char === 'e' && syllables > 1) {
                syllables--;
            }
        }

        // 确保至少有一个音节
        if (syllables === 0) {
            syllables = 1;
        }

        totalSyllables += syllables;
    });

    return totalSyllables;
}
// function pickGlobalCaptions(data) {
//     let fixedDuration = 0;
//     let originDuration = 0;

//     for (let i = 0; i < data.scenes.length; i++) {
//         const scene = data.scenes[i];
//         const md = getMaterialsDuration(scene.materials);
//         if (scene.setting.speed === 'follow_audio') {
//             fixedDuration += md;
//         } else {
//             originDuration += md;
//         }
//     }
//     var captions = [];
//     for (let i = 0; i < data.global_settings.captions.length; i++) {
//         const caption = data.global_settings.captions[i]; // 全局
//         const duration = estimateDuration(caption.content); // 估计台词时间
//         const speedFactor = Math.round((fixedDuration / (duration - originDuration)) * 100) / 100;
//         console.log(caption, duration, fixedDuration, originDuration)
//         console.log("speedFactor", speedFactor)
//         if (speedFactor >= minSpeed && speedFactor <= maxSpeed) {
//             captions.push(caption);
//         }
//     }
//     console.log(captions)
//     return captions;
// }

// 计算全局下的视频合成预计数量
function combGlobalMaterials(data) {
    const sceneCombCount = [];
    for (let i = 0; i < data.scenes.length; i++) {
        const scene = data.scenes[i];
        const combCount =
            scene.setting.clip_rule === "single_video"
                ? scene.materials.length
                : 2 ** scene.materials.length - 1;
        sceneCombCount.push(combCount);
    }
    return sceneCombCount.reduce((acc, cur) => acc * cur, 1);
}

// 生成各分镜组合
function combSenceMaterials(data) {
    const errors = [];
    let maxCount, minDuration, maxDuration;
    if (!data.global_settings.enabled) {
        const combinations = [];
        for (let i = 0; i < data.scenes.length; i++) {
            const result = [];
            const scene = data.scenes[i];
            const durationFix =
                (data.transition[String(i)]?.effects?.length > 0
                    ? data.transition[String(i)]?.duration || 500
                    : 0) / 1000; // 如果有转场需要增加0.5秒时长
            const durations = scene.caption.map(
                (cap) =>
                    estimateDuration(
                        cap.content.map(
                            (str) =>
                                str
                                    .replace(/>\s+</g, "><") // 移除标签之间的空白
                                    .replace(/\s{2,}/g, " ") // 将多个空白字符替换为一个空格
                                    .replace(/<speak>\s+/g, "<speak>") // 移除 <speak> 标签后多余的空白
                                    .replace(/\s+<\/speak>/g, "</speak>") // 移除 </speak> 标签前多余的空白
                                    .trim(), // 去除字符串首尾的空白
                        ) || [],
                        (cap.voice_setting?.default_speed_rate || 20) / 100,
                        true,
                        cap?.voice_setting?.lang == 'en'
                    ) + durationFix,
            ); // 估计台词时间
            const combinationLength =
                scene.setting.clip_rule === "single_video" ? 1 : scene.materials.length; // 单镜头时使用单个素材，多镜头时使用素材数组
            const usedElements = new Set(); // 使用过的元素缓存
            const uniqueElements = scene.setting.clip_rule === "single_times"; // 是否只使用一次（单次魔剪)
            for (let j = 0; j < combinationLength; j++) {
                const combinations = generateCombinations(
                    scene.materials,
                    j + 1,
                    usedElements,
                    uniqueElements,
                );
                for (const comb of combinations) {
                    // 全局配置下不判断分镜
                    if (
                        data.global_settings.enabled ||
                        isValid(comb, durations, scene.setting.speed)
                    ) {
                        // console.log("Item:", comb.map(v => v.id));
                        result.push(comb);
                    }
                }
            }
            if (result.length === 0)
                errors.push({ scene: i, message: scene.setting.speed === "origin" ? "分镜素材时长不足" : "分镜素材不符合变速条件" });
            combinations.push(result);
        }
        maxCount = getCombinationMaxCount(combinations);
        const durationRange = getSceneCaptionDuration(data);
        minDuration = Math.max(durationRange.min - 1, 0);
        maxDuration = durationRange.max > 0 ? durationRange.max + 1 : 0;
    } else {
        maxCount = combGlobalMaterials(data);
        const durationRange = getGlobalCaptionDuration(data);
        minDuration = Math.max(durationRange.min - 1, 0);
        maxDuration = durationRange.max > 0 ? durationRange.max + 1 : 0;
    }

    return {
        maxCount,
        minDuration,
        maxDuration,
        errors,
    };
}
// 预估分镜模式的合成数量
function getCombinationMaxCount(combinations) {
    return combinations.map((v) => v.length).reduce((acc, cur) => acc * cur, 1);
}

function getGlobalCaptionDuration(data) {
    const captionGroupDuration = data.global_settings.captions.map((cap) =>
        estimateDuration(
            cap.content,
            (cap.voice_setting?.default_speed_rate || 20) / 100,
            true,
            cap.voice_setting?.lang == 'en'
        ),
    );
    return {
        min: Math.min(...captionGroupDuration),
        max: Math.max(...captionGroupDuration),
    };
}

// 预估时长，返回最短到最长的秒数
function getSceneCaptionDuration(data) {
    let captionMaxDuration = 0,
        captionMinDuration = 0;
    for (let i = 0; i < data.scenes.length; i++) {
        const scene = data.scenes[i];
        // 分镜台词组的预估时长
        const captionGroupDuration = scene.caption.map((cap) =>
            estimateDuration(
                cap.content,
                (cap.voice_setting?.default_speed_rate || 20) / 100,
                true,
                cap.voice_setting?.lang == 'en'
            ),
        );
        captionMaxDuration += Math.max(...captionGroupDuration);
        captionMinDuration += Math.min(...captionGroupDuration);
    }
    return { min: captionMinDuration, max: captionMaxDuration };
}

// 根据一个视频素材，台词组，以及多行标题，生成一个预览时间轴
function combTimeline(material, caption) {
    console.log(previewStore.getBackground(), 'background')
    if (material?.type === MaterialType.AUDIO) {
        throw new Error("音频素材无法生成时间轴");
    }
    // 初始化视频
    const videoTrack = {
        Id: Date.now() + parseInt(Math.random() * 10000),
        Type: "Video",
        VideoTrackClips: [],
    };

    if (material) {
        videoTrack.VideoTrackClips.push(materialToClip(material));
    }
    let subtitleTrack = {
        Id: Date.now() + parseInt(Math.random() * 10000),
        Type: "Subtitle",
        VideoTrackClips: [],
    };

    let imageTrack = {
        Id: Date.now() + parseInt(Math.random() * 10000),
        Type: "Image",
        VideoTrackClips: [],
    }
    if (QuickStore.quickcutData.settings.copy.show_subtitle && QuickStore.previewTexts?.length > 0) {
        subtitleTrack.VideoTrackClips.push({
            Id: Date.now() + parseInt(Math.random() * 10000),
            Type: "Text",
            X: 0.5,
            Y: 0.67,
            Content: QuickStore.previewTexts[0].slice(0, 10),
            Alignment: 'Center',
            Font: 'Alibaba PuHuiTi',
            FontSize: 40,
            FontUrl: "",
            FontColor: "#ffffff",
            FontColorOpacity: 1,
            TimelineIn: 0,
            TimelineOut: 20,
            AdaptMode: 'AutoWrap',
            TextWidth: 0.8
        })
    }

    if (QuickCutStore.quickcutData.settings.video_template?.length > 0 && QuickCutStore.quickcutData.settings.video_template[0]?.content) {
        const data = JSON.parse(QuickCutStore.quickcutData.settings.video_template[0]?.content)
        data.timeline.VideoTracks.forEach(item => {
            if (item.Type === 'Image') {
                imageTrack = item
            }
            if (item.Type === 'SubTitle') {
                subtitleTrack.VideoTrackClips = item.VideoTrackClips
            }
        })
    }

    const transformArray = (decoration) => {
        return decoration.map((item, index) => ({
            ...(item.material || {}), // 如果 material 不存在，使用空对象
            ...(item.settings || {}), // 如果 settings 不存在，使用空对象
            id: item.id,
            x: item.settings?.x || 0,
            y: item.settings?.y || 0,
        }));
    };

    return {
        VideoTracks: [videoTrack, subtitleTrack, imageTrack],
    };
}

function materialToClip(material, timelineIn = 0) {
    let type = "Video";
    let duration = 0;
    switch (material.type) {
        case MaterialType.VIDEO:
            type = "Video";
            break;
        case MaterialType.IMAGE:
            type = "Image";
            duration = material.duration;
            break;
        default:
            break;
    }
    let Effects = []
    if (QuickCutStore.quickcutData.settings.background.enable_blur) {
        Effects.push({
            Type: "Background",
            SubType: "Blur",
            Radius: 0.1
        })
    }
    if (QuickCutStore.previewFilter?.length > 0) {
        Effects.push({
            Type: QuickCutStore.previewFilter[0].type,
            SubType: QuickCutStore.previewFilter[0].sub_type,
        })
        console.log(typeof Effects, 'Effects')
    }
    return {
        Id: material.id,
        Type: type,
        MediaId: material.media_id || "",
        MediaURL: material.url || "",
        X: material.x || 0,
        Y: material.y || 0,
        // AdaptMode: "Fill",
        In: material.start / 1000.0,
        Out: (material.start + material.duration) / 1000.0,
        TimelineIn: timelineIn / 1000.0 || 0,
        TimelineOut: (timelineIn + material.duration / (material.speed || 1)) / 1000.0,
        Duration: duration / 1000.0,
        Speed: material.speed,
        Effects: type === 'Video' ? Effects : [],
    };
}
function decorationToClip(material, timelineIn = 0, timelineOut = 1) {
    let duration = 0;
    return {
        Id: material?.id,
        Type: 'Image',
        MediaId: material.media_id || "",
        MediaURL: material.url || "",
        X: material.x || 0,
        Y: material.y || 0,
        AdaptMode: "Fill",
        Width: material?.width,
        Height: material?.height,
        In: 1,
        Out: 1,
        TimelineIn: timelineIn / 1000.0,
        TimelineOut: timelineOut / 1000.0,
        Duration: duration / 1000.0,
        Speed: material?.speed || 1,
    };
}

export { estimateDuration, combSenceMaterials, combTimeline };
